import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import cx from 'classnames';
import { DateInfo } from 'govbr.frontend.policy/components';

// Mapeamento simples de mime types para ícones Font Awesome
const mimeTypeToIcon = {
  'application/pdf': 'fa-file-pdf',
  'application/msword': 'fa-file-word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'fa-file-word',
  'application/vnd.ms-excel': 'fa-file-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    'fa-file-excel',
  'application/vnd.ms-powerpoint': 'fa-file-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'fa-file-powerpoint',
  'image/jpeg': 'fa-file-image',
  'image/png': 'fa-file-image',
  'image/gif': 'fa-file-image',
  'image/webp': 'fa-file-image',
  'text/plain': 'fa-file-lines',
  'application/zip': 'fa-file-zipper',
  'application/x-rar-compressed': 'fa-file-zipper',
  'application/x-gzip': 'fa-file-zipper',
  'application/json': 'fa-file-code',
  'application/xml': 'fa-file-code',
  'text/csv': 'fa-file-csv',
};

function getFileIcon(mimeType) {
  if (!mimeType) return 'fa-file';
  return mimeTypeToIcon[mimeType] || 'fa-file';
}

export const FileListing = ({ item }) => {
  const { id, title, description, review_state } = item;

  // Exemplo: item.mime_type pode ser 'application/pdf', etc.

  return (
    <div>
      <div
        className={cx('text-up-02 text-weight-medium text-interactive', {
          [`review-state-${review_state}`]: review_state,
        })}
      >
        {title ? title : id}
      </div>
      <div className="mb-2 text-up-01 text-gray-80">{description}</div>
      <DateInfo item={item} />
      {item.getURL && (
        <div className="mt-1">
          <UniversalLink href={`${item.getURL}/@@download/file`}>
            <i
              className={`fa-solid ${getFileIcon(item.mime_type)} mr-2`}
              aria-hidden="true"
              title={item.mime_type}
            />
            {item.getId}
          </UniversalLink>
          {item.getObjSize && (
            <span className="text-down-01">
              &nbsp;&mdash;&nbsp;{item.getObjSize}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
